import http from '@/http'
import createCrudModule from 'vuex-crud'

export default createCrudModule({
  client: http,
  resource: 'partners/users',
  urlRoot: 'partners/users',
  only: ['CREATE', 'UPDATE'],

  actions: {
    destroy({ commit }, data) {
      commit('updateStart')
      return http
        .delete('partners/users', { data })
        .finally(() => commit('updateComplete'))
    }
  }
})
